import React from 'react';
import { Grid } from 'antd';
import { MessageCircle, Package, ShieldCheck, Store } from 'lucide-react';
import { FOOTER, PUBLIC_SHELL } from '../../config/zinihubConfig';
import ZiniHubIcon from '../../assets/zinihub_icon_RoundEdge.svg';
import styles from '../../styles/PublicShell.module.css';

const { useBreakpoint } = Grid;
const { BRAND, VALUE_PROPS, TRUST_BLOCK } = PUBLIC_SHELL;
const VALUE_PROP_ICONS = [Store, Package, MessageCircle];

function BrandPanel() {
  return (
    <div className={styles.brandPanel}>
      <div className={styles.brandHeader}>
        <div className={styles.brandLogo}><img src={ZiniHubIcon} alt="Ziniz" className={styles.brandLogoImg} /></div>
        <span className={styles.brandName}>{BRAND.NAME}</span>
      </div>
      <div className={styles.brandBody}>
        <div>
          <h2 className={styles.tagline}>
            {BRAND.TAGLINE_DESKTOP_1}<br />{BRAND.TAGLINE_DESKTOP_2}
          </h2>
          <p className={styles.description}>{BRAND.DESCRIPTION}</p>
        </div>
        <div className={styles.valuePropList}>
          {VALUE_PROPS.map(({ label, description }, index) => {
            const Icon = VALUE_PROP_ICONS[index];
            return (
              <div key={label} className={styles.valueProp}>
                <div className={styles.valuePropIconWrap}>
                  <Icon size={22} aria-hidden="true" />
                </div>
                <div className={styles.valuePropContent}>
                  <div className={styles.valuePropLabel}>{label}</div>
                  <div className={styles.valuePropDescription}>{description}</div>
                </div>
              </div>
            );
          })}
        </div>
        <div className={styles.trustBlock}>
          <div className={styles.trustIconWrap}>
            <ShieldCheck size={20} aria-hidden="true" />
          </div>
          <div className={styles.trustContent}>
            <div className={styles.trustTitle}>{TRUST_BLOCK.TITLE}</div>
            <div className={styles.trustDescription}>
              {TRUST_BLOCK.DESCRIPTION_PREFIX}
              <strong>{TRUST_BLOCK.HIGHLIGHT}</strong>
              {TRUST_BLOCK.DESCRIPTION_SUFFIX}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function MobileBrandStrip() {
  return (
    <div className={styles.mobileBrandStrip}>
      <div className={styles.mobileBrandLogo}><img src={ZiniHubIcon} alt="Ziniz" className={styles.mobileBrandLogoImg} /></div>
      <div className={styles.mobileBrandInfo}>
        <div className={styles.mobileBrandName}>{BRAND.NAME}</div>
        <div className={styles.mobileBrandTagline}>{BRAND.TAGLINE}</div>
      </div>
    </div>
  );
}

function AuthFooter() {
  return (
    <div className={styles.footer}>
      {FOOTER.ADMIN}{' '}
      <span className={styles.footerLink}>{FOOTER.BRAND_LINK}</span>
    </div>
  );
}

export default function PublicShell({ children }) {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <div className={styles.shell}>
      <div className={`${styles.body} ${isMobile ? styles.bodyMobile : styles.bodyDesktop}`}>
        {isMobile ? <MobileBrandStrip /> : <BrandPanel />}
        <div className={styles.formArea}>
          <div className={styles.formContainer}>
            {children}
          </div>
        </div>
      </div>
      <AuthFooter />
    </div>
  );
}
